<script setup>
import BaseButton from "@/components/shared/Button/BaseButton.vue";
import ArrowRight from "@/components/shared/icons/ArrowRight.vue";
import MobileAppRedirectQRCode from "@/components/shared/MobileAppRedirectQRCode.vue";
import { useMobile } from "@/composables/useMobile";

const { isMobile } = useMobile();

defineProps({
  formLabel: {
    type: String,
    default: "",
  },
});

const gotoAppRedirect = () => {
  window.location.href = "/go-to-mobile-app";
};
</script>
<template>
  <div class="flex w-full flex-col p-10 gap-8 bg-white">
    <div class="flex w-full flex-col gap-4">
      <div class="flex justify-center">
        <span class="font-montserrat text-2xl font-bold text-university-primary text-center"
          >Complete in The Mobile App</span
        >
      </div>
      <div v-if="isMobile" class="flex justify-center">
        <span class="font-montserrat text-sm font-medium text-university-primary text-center"
          >This form is best completed in the app. Use it to start or edit your submission.</span
        >
      </div>
      <div v-else class="flex justify-center">
        <span class="font-montserrat text-sm font-medium text-university-primary text-center"
          >Scan this code to fill out or update your {{ formLabel }} form in the mobile app.</span
        >
      </div>
      <div v-if="isMobile">
        <div class="flex flex-row justify-center gap-5">
          <div>
            <base-button
              class="min-w-[140px]"
              :rounded="true"
              :filled="true"
              @click="gotoAppRedirect"
              data-test-id="mobile-app-form-completion-button"
              ><div class="flex flex-row gap-2 items-center">
                <span class="font-medium text-base">Continue to App</span
                ><arrow-right :use-alt="true" custom-class="w-4 h-4" /></div
            ></base-button>
          </div>
        </div>
      </div>
      <div v-else class="flex w-full flex-col gap-4">
        <div class="flex flex-row justify-center gap-5">
          <div>
            <img src="/images/mobile-app/app-store.png" alt="App Store" class="h-22 object-contain" />
          </div>
          <div>
            <img src="/images/mobile-app/google-play.png" alt="Google Play Store" class="h-22 object-contain" />
          </div>
        </div>
        <div class="flex justify-center">
          <mobile-app-redirect-q-r-code />
        </div>
        <div class="flex justify-center">
          <span class="font-montserrat text-sm font-medium text-university-primary text-center"
            >This form is best completed on your phone. Use the app to start or edit your submission.</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
